import ColumnsData from "./columns_data";

class RoleData {
    static data() {
        return {
            admin: {slug: "admin", label: "Админ"},
            investor: {slug: "investor", label: "Инвестор"},
            head_of_call_center: {slug: "head_of_call_center", label: "Руководитель КЦ"},
            operator: {slug: "operator", label: "Оператор КЦ"},
            ad_agency: {slug: "ad_agency", label: "Рекламное агенство"},
            head_of_sales_department: {slug: "head_of_sales_department", label: "Руководитель отдела продаж"},
            sales_manager: {slug: "sales_manager", label: "Менеджер по продажам"},
            reception: {slug: "reception", label: "Ресепшен"},
            head_of_credit_department: {slug: "head_of_credit_department", label: "Руководитель КО"},
            credit_manager: {slug: "credit_manager", label: "Кредитный специалист"},
            cashier: {slug: "cashier", label: "Кассир"},
            supervisor: {slug: "supervisor", label: "Супервайзер"},
        };
    }
    static dataAsArray() {
        let arr = [];
        let data = this.data();
        for (status in data) {
            arr.push(data[status])
        }
        return arr;
    }
    static getBySlug(slug) {
        let f = this.data()[slug];
        if (f) return f;
        return null;
    }
    static forSelect() {
        return this.dataAsArray().map(function (item) {
            return {id: item.slug, text: item.label};
        })
    }
    static hasPermissionInterface(user, name) {
        // car.form.show
        // car.form.tab_files
        // car.form.tab_operations
        // car.form.cost_accumulated
        // car.form.cost_increase

        // request.form.deals.show
        // deal.form.show
        // deal.documents_generate
        // deal.affiliate_sales

        let data = {
            admin: ["car.form.tab_files", "car.form.tab_operations", "car.form.cost_accumulated", "car.form.cost_increase", "car.form.show", "request.form.deals.show", "deal.form.show", "deal.documents_generate", "deal.affiliate_sales"],
            investor: ["car.form.tab_files", "car.form.tab_operations", "car.form.cost_accumulated", "car.form.cost_increase", "car.form.show", "request.form.deals.show", "deal.form.show", "deal.documents_generate", "deal.affiliate_sales"],
            head_of_call_center: [],
            operator: [],
            ad_agency: [],
            head_of_sales_department: ["car.form.tab_files", "car.form.tab_operations", "car.form.cost_accumulated", "car.form.cost_increase", "car.form.show", "request.form.deals.show", "deal.form.show", "deal.documents_generate", "deal.affiliate_sales"],
            sales_manager: ["request.form.deals.show", "deal.documents_generate"],
            head_of_credit_department: ["car.form.tab_files", "car.form.cost_accumulated", "car.form.cost_increase", "car.form.show", "request.form.deals.show", "deal.form.show", "deal.documents_generate", "deal.affiliate_sales"],
            credit_manager: ["request.form.deals.show", "deal.form.show", "deal.documents_generate", "deal.affiliate_sales"],
            cashier: ["car.form.tab_files", "car.form.tab_operations", "car.form.cost_accumulated", "car.form.cost_increase", "car.form.show", "request.form.deals.show", "deal.form.show", "deal.documents_generate", "deal.affiliate_sales"],
            supervisor: [],
        }

        let permissions = [];
        if (user.roles) {
            user.roles.forEach(r => {
                let role_permissions = data[r.name];
                if (role_permissions && role_permissions.length) permissions = permissions.concat(role_permissions);
            });
        }
        permissions = _.uniq(permissions);

        return permissions.includes(name);
    }

    static hasPermissionStatus(user, entity, status) {
        let data = {
            request_status: {
                admin: ['new','in_work','not_answer','non_call','arrived','not_marked_in_salon','bought','will_arrive','approve','rejection','incorrect_data',],
                investor: [],
                head_of_call_center: ['new','in_work','not_answer','non_call','not_marked_in_salon','will_arrive','approve','rejection','incorrect_data',],
                operator: ['new','in_work','not_answer','non_call','not_marked_in_salon','will_arrive','approve','rejection','incorrect_data',],
                ad_agency: [],
                head_of_sales_department: ['arrived','bought',],
                sales_manager: ['arrived','bought',],
                reception: ['arrived',],
                head_of_credit_department: [],
                credit_manager: [],
                cashier: [],
                supervisor: ['new','in_work','not_answer','non_call','not_marked_in_salon','will_arrive','approve','rejection','incorrect_data',],
            },
            request_credit_status: {
                admin: ['in_work','consultation','consideration','limit','approved','soglasovanie_ts','ozidanie','dokumenty_gotovy','jumped','rejection','issued',],
                investor: [],
                head_of_call_center: [],
                operator: [],
                ad_agency: [],
                head_of_sales_department: [],
                sales_manager: [],
                head_of_credit_department: ['in_work','consultation','consideration','limit','approved','soglasovanie_ts','ozidanie','dokumenty_gotovy','jumped','rejection','issued',],
                credit_manager: ['in_work','consultation','consideration','limit','approved','soglasovanie_ts','ozidanie','dokumenty_gotovy','jumped','rejection','issued',],
                cashier: [],
                supervisor: [],
            },
            credit_request_status: {
                admin: ['rassmotrenie','otkaz','otkaz_skoring','otkaz_ds','np_vozrast','np_region','np_vu','np_fssp','odobren','limit_po_klientu','limit_po_ts','soglasovanie_ts','ozidanie','dokumenty_gotovy','oformlen','ne_otpravljat','chernovik','skoring_otpravit',],
                investor: [],
                head_of_call_center: [],
                operator: [],
                ad_agency: [],
                head_of_sales_department: [],
                sales_manager: [],
                head_of_credit_department: ['rassmotrenie','otkaz','otkaz_skoring','otkaz_ds','np_vozrast','np_region','np_vu','np_fssp','odobren','limit_po_klientu','limit_po_ts','soglasovanie_ts','ozidanie','dokumenty_gotovy','oformlen','ne_otpravljat','chernovik','skoring_otpravit',],
                credit_manager: ['rassmotrenie','otkaz','otkaz_skoring','otkaz_ds','np_vozrast','np_region','np_vu','np_fssp','odobren','limit_po_klientu','limit_po_ts','soglasovanie_ts','ozidanie','dokumenty_gotovy','oformlen','ne_otpravljat','chernovik','skoring_otpravit',],
                cashier: [],
                supervisor: [],
            },
            car_status: {
                admin: ['on_way','in_salon','in_service','recalled',],
                investor: [],
                head_of_call_center: [],
                operator: [],
                ad_agency: [],
                head_of_sales_department: ['on_way','in_salon','in_service','recalled',],
                sales_manager: [],
                head_of_credit_department: ['on_way','in_salon','in_service','recalled',],
                credit_manager: [],
                cashier: ['on_way','in_salon','in_service','recalled',],
                supervisor: ['on_way','in_salon','in_service','recalled',],
            }
        }

        let permissions = [];
        if (user.roles) {
            user.roles.forEach(r => {
                let role_permissions = data[entity][r.name];
                if (role_permissions && role_permissions.length) permissions = permissions.concat(role_permissions);
            });
        }
        permissions = _.uniq(permissions);

        return permissions.includes(status);
    }
}

export default RoleData;
